/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CardAttachmentDto,
  CardSpendResponseCardOrderDto,
  CardSpendResponseCardResponse,
  CreateCardRequestDto,
  UpdateCardRequest,
  UploadCardAttachmentPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSpendRequestController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name RequestUpdateCard
   * @request PUT:/api/v1/spend-request/card
   */
  requestUpdateCard = (data: UpdateCardRequest, params: RequestParams = {}) =>
    this.http.request<CardSpendResponseCardResponse, any>({
      path: `/v1/spend-request/card`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestUpdateCardPath = '/v1/spend-request/card'
  static requestUpdateCardMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name RequestCreateCard
   * @request POST:/api/v1/spend-request/card
   */
  requestCreateCard = (data: CreateCardRequestDto, params: RequestParams = {}) =>
    this.http.request<CardSpendResponseCardOrderDto, any>({
      path: `/v1/spend-request/card`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestCreateCardPath = '/v1/spend-request/card'
  static requestCreateCardMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name UploadCardAttachment
   * @request POST:/api/v1/spend-request/cards/attachment
   */
  uploadCardAttachment = (data: UploadCardAttachmentPayload, params: RequestParams = {}) =>
    this.http.request<CardAttachmentDto, any>({
      path: `/v1/spend-request/cards/attachment`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadCardAttachmentPath = '/v1/spend-request/cards/attachment'
  static uploadCardAttachmentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name GetCardAttachmentThumbnail
   * @request GET:/api/v1/spend-request/cards/attachment/{id}/thumbnail
   */
  getCardAttachmentThumbnail = (id: string, params: RequestParams = {}) =>
    this.http.request<CardAttachmentDto, any>({
      path: `/v1/spend-request/cards/attachment/${id}/thumbnail`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCardAttachmentThumbnailPath = '/v1/spend-request/cards/attachment/${id}/thumbnail'
  static getCardAttachmentThumbnailMethod = 'GET'
  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name DownloadCardAttachment
   * @request GET:/api/v1/spend-request/cards/attachment/{id}/download
   */
  downloadCardAttachment = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/spend-request/cards/attachment/${id}/download`,
      method: 'GET',
      ...params,
    })

  static downloadCardAttachmentPath = '/v1/spend-request/cards/attachment/${id}/download'
  static downloadCardAttachmentMethod = 'GET'
  /**
   * No description
   *
   * @tags api-spend-request-controller
   * @name DeleteAttachment
   * @request DELETE:/api/v1/spend-request/cards/attachment/{id}
   */
  deleteAttachment = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/spend-request/cards/attachment/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteAttachmentPath = '/v1/spend-request/cards/attachment/${id}'
  static deleteAttachmentMethod = 'DELETE'
}
